import { BannerVariant } from 'app/components/core/Banner';
import { ErrorLevel } from 'app/lib/constants';

export const getBannerVariantFromErrorLevel = (level?: ErrorLevel): BannerVariant => {
    switch (level) {
        case ErrorLevel.ERROR:
            return BannerVariant.ERROR;
        case ErrorLevel.WARNING:
            return BannerVariant.WARNING;
        default:
            return BannerVariant.WARNING;
    }
};
